const Link = ({ children, href }: { children: React.ReactNode; href: string }) => {
  return (
    <a href={href} className='text-grey500 font-[MuseoSansCyrl] underline'>
      {children}
    </a>
  );
};

export default Link;
